export default {
  // Forcing organization for fetchJSON
  // Sould always be a string for consistancy
  ORGANIZATION_ID: "",
};
